var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_778_9175)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.33333,
    cy: 14.6668,
    r: 9.33333,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.33333,
    cy: 14.6668,
    r: 9.33333,
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1663 16.5002H6.83301V3.50016C6.83301 3.4085 6.75801 3.3335 6.66634 3.3335H5.49967C5.40801 3.3335 5.33301 3.4085 5.33301 3.50016V17.8335C5.33301 17.9252 5.40801 18.0002 5.49967 18.0002H21.1663C21.258 18.0002 21.333 17.9252 21.333 17.8335V16.6668C21.333 16.5752 21.258 16.5002 21.1663 16.5002ZM9.03717 13.2856C9.10176 13.3502 9.20592 13.3502 9.27259 13.2856L12.1538 10.4189L14.8122 13.0939C14.8768 13.1585 14.983 13.1585 15.0476 13.0939L20.7851 7.3585C20.8497 7.29391 20.8497 7.18766 20.7851 7.12308L19.9601 6.29808C19.9288 6.26706 19.8865 6.24966 19.8424 6.24966C19.7983 6.24966 19.756 6.26706 19.7247 6.29808L14.933 11.0877L12.2788 8.41683C12.2475 8.38581 12.2052 8.36841 12.1611 8.36841C12.1171 8.36841 12.0747 8.38581 12.0434 8.41683L8.21426 12.2231C8.18324 12.2544 8.16584 12.2967 8.16584 12.3408C8.16584 12.3849 8.18324 12.4272 8.21426 12.4585L9.03717 13.2856Z",
    fill: "black",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_778_9175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.502dc26ca3d22674feb788185f1df442.svg";
export { ForwardRef as ReactComponent };